


























































































































































import Vue from 'vue'
import InfoModal from './InfoModal.vue'
import ReinforcementsModal from './ReinforcementsModal.vue'
import { Npc, Statblock } from '@/class'

export default Vue.extend({
  name: 'encounter-nav',
  components: { InfoModal, ReinforcementsModal },
  props: {
    encounter: {
      type: Object,
      required: true,
    },
    mission: {
      type: Object,
      required: true,
    },
    actor: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    reaction: '',
    reason: '',
    remove: ['Destroyed', 'Routed', 'Escaped', 'Retreated'],
    reactionDialog: false,
    removeDialog: false,
    repairDialog: false,
    statBlockDialog: false,
    deleteDialog: false,
    reinforcementDialog: false,
    noteSheet: false,
    statBlockNpc: null,
  }),
  methods: {
    react() {
      this.actor.AddReaction(this.reaction)
      this.reaction = ''
      this.close()
    },
    statBlock() {
      return Statblock.GenerateNPC(this.statBlockNpc)
    },
    copyStatBlock() {
      navigator.clipboard
        .writeText(this.statBlock())
        .then(() => Vue.prototype.$notify('Stat block copied to clipboard.', 'confirmation'))
        .catch(() => Vue.prototype.$notifyError('Unable to copy stat block'))
    },
    setStatBlock(npc: Object) {
      this.statBlockNpc = npc
      this.statBlockDialog = true
    },
    removeActor() {
      this.actor.Defeat = this.reason
      this.reason = ''
      this.close()
    },
    repair() {
      this.actor.FullRepair()
      this.close()
    },
    deleteActor() {
      this.$emit('delete-actor')
      this.close()
    },
    close() {
      this.reactionDialog = false
      this.removeDialog = false
      this.repairDialog = false
      this.statBlockDialog = false
      this.deleteDialog = false
    },
  },
})
